<main class="qr-page">
  <header class="page-header">
    <div>
      <p class="eyebrow">Admin tool</p>
      <h1>QR Code Generator</h1>
      <p class="page-description">
        Create a scannable QR code for a website or a pre-filled WhatsApp message.
      </p>
    </div>
  </header>

  <section class="instructions" aria-labelledby="instructions-title">
    <div class="instructions-heading">
      <span nz-icon nzType="info-circle" nzTheme="outline" aria-hidden="true"></span>
      <div>
        <h2 id="instructions-title">How to create your QR code</h2>
        <p>Follow these steps before sharing or printing it.</p>
      </div>
    </div>

    <ol class="instruction-steps">
      <li>
        <span class="step-number">1</span>
        <span><strong>Choose a destination</strong> by entering a URL or creating a WhatsApp link.</span>
      </li>
      <li>
        <span class="step-number">2</span>
        <span><strong>Generate and test</strong> the QR code with your phone.</span>
      </li>
      <li>
        <span class="step-number">3</span>
        <span><strong>Download the PNG</strong> when you are happy with the result.</span>
      </li>
    </ol>
  </section>

  <div class="qr-workspace">
    <section class="panel builder-panel" aria-labelledby="destination-title">
      <div class="panel-heading">
        <span class="panel-icon" nz-icon nzType="link" nzTheme="outline" aria-hidden="true"></span>
        <div>
          <h2 id="destination-title">QR code destination</h2>
          <p>This is the link that will open when someone scans the code.</p>
        </div>
      </div>

      <div class="field-group">
        <label for="qr-code-url">Destination URL</label>
        <input
          id="qr-code-url"
          nz-input
          type="url"
          [(ngModel)]="url"
          (ngModelChange)="onUrlChange()"
          [attr.aria-invalid]="hasUrlError"
          aria-describedby="url-help url-error"
          placeholder="https://example.com"
        />
        <p id="url-help" class="field-help">Paste the full link, including https://</p>

        <p *ngIf="hasUrlError" id="url-error" class="error-message" role="alert">
          <span nz-icon nzType="exclamation-circle" nzTheme="outline" aria-hidden="true"></span>
          Enter a URL before generating a QR code.
        </p>
      </div>

      <div class="section-divider" role="separator">
        <span>OR USE THE WHATSAPP HELPER</span>
      </div>

      <div class="whatsapp-helper">
        <div class="helper-heading">
          <span class="panel-icon secondary" nz-icon nzType="message" nzTheme="outline" aria-hidden="true"></span>
          <div>
            <h3>Create a pre-filled WhatsApp link</h3>
            <p>
              The customer will be prompted to send this message to
              <strong>+27 66 453 2826</strong>.
            </p>
          </div>
        </div>

        <div class="field-group">
          <label for="whatsapp-message">Pre-filled message</label>
          <textarea
            id="whatsapp-message"
            nz-input
            rows="4"
            [(ngModel)]="message"
            (ngModelChange)="hasMessageError = false"
            [attr.aria-invalid]="hasMessageError"
            aria-describedby="message-help message-error"
            placeholder="Enter the message the customer should send"
          ></textarea>
          <p id="message-help" class="field-help">
            Keep it short and specific. The customer can edit it before sending.
          </p>

          <p *ngIf="hasMessageError" id="message-error" class="error-message" role="alert">
            <span nz-icon nzType="exclamation-circle" nzTheme="outline" aria-hidden="true"></span>
            Enter a message before creating a WhatsApp link.
          </p>
        </div>

        <button class="helper-action" (click)="createWhatsAppUrl()" nz-button nzType="default">
          <span nz-icon nzType="link" nzTheme="outline"></span>
          Use WhatsApp link
        </button>
      </div>

      <div class="primary-action">
        <button (click)="generateQRCode()" nz-button nzType="primary" nzSize="large">
          <span nz-icon nzType="qrcode" nzTheme="outline"></span>
          Generate QR code
        </button>
      </div>
    </section>

    <section class="panel preview-panel" aria-labelledby="preview-title" aria-live="polite">
      <div class="panel-heading">
        <span class="panel-icon" nz-icon nzType="eye" nzTheme="outline" aria-hidden="true"></span>
        <div>
          <h2 id="preview-title">Preview</h2>
          <p>Your generated QR code will appear here.</p>
        </div>
      </div>

      <div *ngIf="!isVisible" class="empty-preview">
        <div class="empty-preview-icon">
          <span nz-icon nzType="qrcode" nzTheme="outline" aria-hidden="true"></span>
        </div>
        <h3>Ready when you are</h3>
        <p>Enter a destination, then select <strong>Generate QR code</strong>.</p>
      </div>

      <div id="download" *ngIf="isVisible" class="generated-preview">
        <div class="success-label">
          <span nz-icon nzType="check-circle" nzTheme="fill" aria-hidden="true"></span>
          QR code generated
        </div>

        <div class="qr-code-frame">
          <nz-qrcode [nzValue]="url" [nzPadding]="2" [nzSize]="280"></nz-qrcode>
        </div>

        <div class="destination-summary">
          <span>Destination</span>
          <a [href]="url" target="_blank" rel="noopener noreferrer" [title]="url">{{ url }}</a>
        </div>

        <p class="test-reminder">
          <span nz-icon nzType="mobile" nzTheme="outline" aria-hidden="true"></span>
          Scan the code with a phone and confirm that the correct destination opens.
        </p>

        <a #downloadLink class="download-link" aria-hidden="true"></a>
        <button class="download-button" nz-button nzType="primary" nzSize="large" (click)="downloadQrCode()">
          <span nz-icon nzType="download" nzTheme="outline"></span>
          Download PNG
        </button>
      </div>
    </section>
  </div>
</main>
